import { Faction } from "@xanadu/model";
import { DataCache } from "./data.cache";
import { DataService } from "../../service/data/data.service";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class FactionCache extends DataCache<Faction> {
    constructor(
        dataService: DataService
    ) {
        super(Faction, dataService);
    }
}
